import img from '@/assets/images/img/oversight.png';

export const OVERSIGHT_CONFIG = {
  name: 'Oversight',
  browserTitle: 'Oversight',
  info: 'Oversight',
  copyright: 'Copyright (c)',
  right: 'Oversight',
  details: null,
  img,
  productName: 'Oversight',
  hiddenRoutes: ['updatesProgram'],
};
